import { type ICurrencyType } from '@mahawi/eshop-common/src/types';
import { useMemo } from 'react';

export function useCurrencyMap(
  currencies: ICurrencyType[] | undefined,
): Map<string, ICurrencyType> {
  return useMemo((): Map<string, ICurrencyType> => {
    const map = new Map<string, ICurrencyType>();
    for (const c of currencies || []) map.set(c.isoCode, c);
    return map;
  }, [currencies]);
}
